import { router } from '@inertiajs/react'

interface ImpersonationBannerProps {
  orgName: string
}

export default function ImpersonationBanner({ orgName }: ImpersonationBannerProps) {
  return (
    <div className="flex items-center justify-center gap-3 px-4 py-2 text-[13px] font-medium shrink-0 bg-amber-50 border-b border-amber-500 text-amber-800">
      <span>Viewing as <strong>{orgName}</strong></span>
      <button
        onClick={() => router.post('/admin/impersonation/stop')}
        className="rounded border px-2.5 py-0.5 text-xs font-medium cursor-pointer bg-white border-gray-300 text-gray-700"
      >
        Exit
      </button>
    </div>
  )
}
